import {
    AddIcon,
    ArrowRightIcon,
    Button,
    Divider,
    Flex,
    Input,
    PhoneClockIcon,
    ShiftActivityIcon,
    Text,
    TrashCanIcon,
} from "@fluentui/react-northstar";
import { Clock } from "@mui/x-date-pickers/ClockPicker/Clock";
import moment from "moment";

import React, { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import TimeField from "react-simple-timefield";
import styled from "styled-components";
import { updateTimeReporting } from "../../api";
import Toast from "../../../../components/Alerts";
import { BreakFlex, BreakText } from "./EditedSlots";
import StripedTypeLeaveWeek from "../StripedTypeLeaveWeek";

export default function EditSlotDialogContent({
    slot_data,
    refetchSlotData,
    setShowEditDialog,
    setOpenDialog,
    dayId,
    setConfigToast,
}) {
    const [timeSlots, setTimeSlots] = useState(slot_data.shifts ?? []); // Liste des créneaux

    const [displayToast, setDisplayToast] = useState({
        visible: false,
        content: "",
        level: "",
    });
    const validSlots = timeSlots.filter((slot) => slot.id !== -1);
    const addTimeSlot = () => {
        // Filtre les créneaux en returnant uniquement ceux qui ont un type.leave_name vide
        const filteredSlots = timeSlots.filter(
            (slot) => !slot.type?.leave_name
        );
        return setTimeSlots([
            ...filteredSlots,
            { start_hour: "", end_hour: "", id: 0 },
        ]);
    };

    const queryClient = useQueryClient();

    const { mutate } = useMutation(({ dayId, timeSlots }) => {
        return updateTimeReporting(dayId, timeSlots);
    });

    const updateTimeSlot = (index, type, value) => {
        setTimeSlots((prevSlots) =>
            prevSlots.map((slot, i) =>
                i === index ? { ...slot, [type]: value } : slot
            )
        );
    };

    const deleteTimeSlot = (index) => {
        const updatedSlots = timeSlots.filter((_, i) => i !== index);
        setTimeSlots(updatedSlots);
    };

    const _formated_time = (time) => {
        return moment(time, "HH:mm:ss").format("HH:mm");
    };
    const _resetDialog = () => {
        setShowEditDialog(false);
        setOpenDialog(false);
    };

    const _validateTimeSlot = () => {
        // Afficher un toast de succès pendant 2 sec
        // setShowEditDialog(false);

        mutate(
            {
                dayId,
                timeSlots,
            },
            {
                onSuccess: (response) => {
                    console.log({ response });
                    if (response.success) {
                        setShowEditDialog(false); // Ferme la modale

                        queryClient.refetchQueries([
                            "timeline::getSlotDataByDate",
                            dayId,
                        ]);
                        // Afficher le toast de succès

                        setConfigToast({
                            visible: true,
                            content:
                                "Vos modifications ont bien été enregistrées. Le collaborateur recevra une notification.",
                            level: "success",
                        });

                        // Rafraîchir les données après la fermeture du modal

                        // Réinitialiser le formulaire ou d'autres états
                        // _resetDialog();
                    } else {
                        // Afficher le toast d'erreur et laisser le modal ouvert
                        setConfigToast({
                            visible: true,
                            content: response.error,
                            level: "danger",
                        });
                    }
                },
            }
        );
    };

    // Vos modifications ont bien été enregistrées. Le collaborateur recevra une notification.

    return (
        <Flex gap="gap.medium" column>
            <ActualSlotText content="Créneaux actuels" />

            {slot_data?.shifts?.map((slot, index) => {
                if (slot?.id === -1) {
                    // Afficher le composant pour la pause
                    return (
                        <BreakFlex
                            key={index} // Ajout d'une clé pour chaque élément dans le map
                            BreakRespected={slot?.pause_respected}
                            fill
                            hAlign="center"
                        >
                            <BreakText content={`Pause : ${slot?.duration}`} />
                        </BreakFlex>
                    );
                }

                // Afficher le composant pour les autres types de slots
                return slot?.type.leave_name ? (
                    <StripedTypeLeaveWeek
                        background_color={slot.type?.leave_color + "50"}
                        leave_name={slot.type?.leave_name}
                        striped_color={slot.type?.leave_color}
                        pending={slot?.type?.is_pending_leave}
                        Show_leave_name={true}
                    />
                ) : (
                    <ActualSlotFlex key={index} column>
                        <Flex gap="gap.medium" vAlign="center">
                            <SlotText
                                content={_formated_time(slot?.start_time)}
                            />
                            <ArrowRightIcon />
                            <SlotText
                                content={_formated_time(slot?.end_time)}
                            />
                        </Flex>
                        <DurationText
                            content={`Durée : ${slot?.duration_str}`}
                        />
                    </ActualSlotFlex>
                );
            })}

            <Divider />

            <EditSlotText content="Modification des créneaux" />
            {/* toast d'habitude en haut avec useToast */}
            <Toast
                {...displayToast}
                onStatusChange={() =>
                    setDisplayToast({
                        visible: false,
                        content: "",
                        level: "",
                    })
                }
            />
            {/* toast d'habitude en haut avec useToast */}

            {/* modification des crénaux  */}
            {/* modification des crénaux  */}
            {/* modification des crénaux  */}
            <>
                {timeSlots?.map(
                    (slot, index) =>
                        slot?.id !== -1 &&
                        !slot?.type?.leave_name && (
                            <TimeFieldFlex gap="gap.large" fill vAlign="center">
                                <TimeField
                                    style={{ width: "100px" }}
                                    value={slot?.start_time || ""}
                                    input={
                                        <Input
                                            icon={
                                                <ShiftActivityIcon
                                                    styles={{
                                                        color: "#5b5fc7",
                                                    }}
                                                />
                                            }
                                            // error={el?.errors?.f1}
                                            placeholder="00:00"
                                            fluid
                                            // disabled={el?.locked}
                                        />
                                    }
                                    colon=":"
                                    onChange={(e) =>
                                        updateTimeSlot(
                                            index,
                                            "start_hour",
                                            e.target.value
                                        )
                                    }
                                />
                                <ArrowRightIcon />
                                <TimeField
                                    style={{ width: "100px" }}
                                    value={slot.end_time || ""}
                                    input={
                                        <Input
                                            icon={
                                                <ShiftActivityIcon
                                                    styles={{
                                                        color: "#5b5fc7",
                                                    }}
                                                />
                                            }
                                            // error={el?.errors?.f2}
                                            placeholder="00:00"
                                            fluid
                                            // disabled={el?.locked}
                                        />
                                    }
                                    colon=":"
                                    onChange={(e) =>
                                        updateTimeSlot(
                                            index,
                                            "end_hour",
                                            e.target.value
                                        )
                                    }
                                />
                                <Button
                                    onClick={() => deleteTimeSlot(index)}
                                    content={
                                        <Flex
                                            fill
                                            gap="gap.small"
                                            vAlign="center"
                                        >
                                            <TrashCanIcon
                                                styles={{ color: "#C4314B" }}
                                            />
                                            <DeleteSlotText content="Supprimer" />
                                        </Flex>
                                    }
                                    text
                                />
                            </TimeFieldFlex>
                        )
                )}
            </>
            <Divider />
            <AddSlotFlex>
                <Button
                    icon={<AddIcon />}
                    content={"Ajouter un créneau"}
                    text
                    primary
                    onClick={addTimeSlot}
                    disabled={timeSlots.length >= 4 && validSlots.length >= 4}
                />
            </AddSlotFlex>
            <Flex
                styles={{ marginTop: "24px", marginBottom: "-24px" }}
                hAlign="center"
                gap="gap.medium"
            >
                <Button content="Annuler" onClick={_resetDialog} />
                <Button
                    onClick={_validateTimeSlot}
                    content="Enregistrer Le jour"
                    primary
                />
            </Flex>
        </Flex>
    );
}

const TimeFieldFlex = styled(Flex)``;

const AddSlotFlex = styled(Flex)`
    border-bottom: 1px solid #9299f7;
    background: #f5f5f5;
    height: 48px;
    align-items: center;
`;

const DeleteSlotText = styled(Text)`
    color: #c4314b;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    text-decoration: underline;
`;

const SlotText = styled(Text)`
    color: #242424;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;

const ActualSlotFlex = styled(Flex)`
    border-radius: 16px;
    background: #eff6fc;
    padding: 8px 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
`;

const ActualSlotText = styled(Text)`
    color: #242424;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
`;

const EditSlotText = styled(Text)`
    color: #424242;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
`;

const DurationText = styled(Text)`
    color: #242424;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
`;
